//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BaseLoadingComponent',
  props: {
    keyMessage: {
      type: String,
      required: false,
      default: 'frases.loading'
    }
  }
};